import script from "./CollapseButton.vue?vue&type=script&setup=true&lang=js"
export * from "./CollapseButton.vue?vue&type=script&setup=true&lang=js"

import "./CollapseButton.vue?vue&type=style&index=0&id=24b9b5e8&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24b9b5e8"]])

export default __exports__